module.exports = __webpack_public_path__ + "static/media/3.01b8a03d.jpg";